import React, { useEffect } from "react";
import {
  LoadingPopup,
  B2BSpinner,
  PoweredByHopper,
  useDeviceTypes,
} from "halifax";
import {
  CallState,
  FlightBookType,
  VIEWED_FLIGHT_BOOK_PROCESSING,
} from "redmond";
import dayjs from "dayjs";
import clsx from "clsx";
import { BookingInProgressModalConnectorProps } from "./container";
import { trackEvent } from "../../../../api/v0/analytics/trackEvent";
import "./styles.scss";
import * as textConstants from "./textConstants";

export interface IBookingInProgressModalProps
  extends BookingInProgressModalConnectorProps {
  useHighZIndex?: boolean;
  hidePriceQuoteInProgress?: boolean;
}

export const BookingInProgressModal = ({
  inProgress,
  finalizedItinerary,
  isWaitingPriceQuote,
  isRefetchingPriceQuote,
  schedulePaymentCallState,
  useHighZIndex,
  flightBookType,
  seatMapLoading,
  hidePriceQuoteInProgress,
}: IBookingInProgressModalProps) => {
  const runtime = dayjs();
  const { matchesMobile } = useDeviceTypes();

  useEffect(() => {
    switch (flightBookType) {
      case FlightBookType.CHANGE_FOR_ANY_REASON_EXERCISE:
      case FlightBookType.DEFAULT:
        if (finalizedItinerary) {
          trackEvent({
            eventName: VIEWED_FLIGHT_BOOK_PROCESSING,
            properties: {
              runtime: dayjs().diff(runtime, "second"),
            },
          });
        }
        break;
      default:
        break;
    }
  }, [inProgress, finalizedItinerary, flightBookType]);

  const getMessage = () => {
    switch (flightBookType) {
      case FlightBookType.CHANGE_FOR_ANY_REASON_EXERCISE:
      case FlightBookType.DEFAULT: {
        if (
          isRefetchingPriceQuote &&
          schedulePaymentCallState === CallState.InProcess
        ) {
          return textConstants.BOOK_YOUR_FLIGHT;
        }
        if (isWaitingPriceQuote || seatMapLoading) {
          return textConstants.SAVING_TRAVELERS_AND_CHECKING_AVAILABILITY;
        }
        return textConstants.BOOK_YOUR_FLIGHT;
      }
      default:
        return "";
    }
  };
  const isOpen =
    !finalizedItinerary &&
    (inProgress ||
      (isWaitingPriceQuote && !hidePriceQuoteInProgress) ||
      seatMapLoading);

  if (!isOpen) return null;

  return (
    <LoadingPopup
      classes={[
        clsx("flights-book-booking-in-progress-modal", {
          mobile: matchesMobile,
          "high-z-index": useHighZIndex,
        }),
      ]}
      indicatorSize="small"
      indicator={B2BSpinner}
      open
      popupSize="small"
      message={getMessage()}
      footer={PoweredByHopper}
      textAlign="center"
    />
  );
};
